module.exports = __webpack_public_path__ + "static/media/white-down-arrow-png-2.44f28ff5.png";